module.exports = __webpack_public_path__ + "static/img/testimony (57).68432392.jpg";